import classNames from 'classnames'
import React from 'react'

import styles from '../WindowContent.module.scss'

import statusStyles from './StatusView.module.scss'

export const SuccessView = () => {
  return (
    <div className={classNames(styles.center, styles.warningText)}>
      Your call is being started, please go to the{' '}
      <span className={statusStyles.mark__red}>MyConnect app</span>
    </div>
  )
}
